module.exports = __webpack_public_path__ + "img/icon2.55cf6927.png";